<div class="period">
    <span class="period__text" (click)="onClickHandler()">
        {{ periodText }}
    </span>
    <!-- <span class="period__button" *ngIf="canBeClear" (click)="onClearHandler()">
        <img src="./assets/img/svg/krest-blue.svg" alt="Очистить" />
    </span> -->
</div>
